const $doc = $(document);

$doc.on('click', '.js-load-more', function(e) {
  e.preventDefault();
  const $this = $(this);
  const moreItemsNumber = $this.data('more-items');
  const $moreItems = $('.js-load-items');

  $moreItems
    .find('.hidden').each(function(idx) {
      if (idx < moreItemsNumber) {
        $(this).removeClass('hidden');
      } else {
        return false;
      }
    });

  if ($moreItems.find('.hidden').length == 0) {
    $this.addClass('hidden');

    if ($this.parent().hasClass('js-load-more-parent')) {
      $this.parent().addClass('hidden');
    };
  };
});



// WEBPACK FOOTER //
// ../assets/js/load-more-items.js